import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    GET_ALL_DAYS,
    SAVE_REGULARIZATION,
    GET_REGULARIZATION_DETAILS,
    SAVE_NOT_AT_SITE_ATTENDANCE,
    GET_ATTENDANCE_DETAILS,
    MARK_CHECK_OUT,
    REGULARIZE_ATTENDANCE,
    GET_REGULARIZATION_FILTER,
    ATTENDANCE_DATA,
    MONTHS_FILTER
} from "./type";

export const getDaysData = (month, year) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getAllDays}?month=${month}&year=${year}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_ALL_DAYS,
            payload: data.response,
        });
        return true;
    }
};

export const saveRegularization = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveAttendanceRegularization}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_REGULARIZATION,
            payload: data.response,
        });
        return true;
    }
};

export const regularizationDetailsForManager = (page = 1, listStatus=[], requestId = null, requestType = null, filterData = [{}]) => async (dispatch) => {
    console.log("TEST 2: ", page)
    let url = `${Config.getRegularizationDetails}?page=${page}`;

    if (listStatus.length > 0) {
        url += `&list_status=${listStatus.join(',')}`;
    }

    if (requestId !== null && requestId !== undefined) {
        url += `&request_id=${requestId}`;
    }

    if (requestType !== null && requestType !== undefined) {
        url += `&request_type=${requestType}`;
    }

    Object.keys(filterData[0]).map((val, i)=>{
        url+="&"+val+"="+filterData[0][val]
    })

    const res = await callWebService(
        callTypes.get,
        '',
        url
    );

    if (res) {
        const { data } = res;
        dispatch({
            type: GET_REGULARIZATION_DETAILS,
            payload: data.response,
        });
        return true;
    }
    return false;
};


export const markCheckIn = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.markNonSiteCheckIn}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_NOT_AT_SITE_ATTENDANCE,
            payload: data.response,
        });
        return true;
    }
};

export const getTheAttendanceDetails = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getAttendanceDetails}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_ATTENDANCE_DETAILS,
            payload: data.response,
        });
        return true;
    }
};

export const markCheckOut = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.patch,
        data,
        `${Config.markNonSiteCheckOut}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MARK_CHECK_OUT,
            payload: data.response,
        });
        return true;
    }
};

export const regularizeAttendance = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.patch,
        data,
        `${Config.updateRegularizationDetails}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: REGULARIZE_ATTENDANCE,
            payload: data.response,
        });
        return data.response;
    }
};

export const getRegularizationRequestFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getRegularizationFilter}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_REGULARIZATION_FILTER,
            payload: data.response,
        });
        return true;
    }
};

export const meetingDataForADate = (particularDate) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.meetingDataForParticularDate}?date=${particularDate}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ATTENDANCE_DATA,
            payload: data.response,
        });
        return true;
    }
};

export const getMonthsNameFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getMonthsFilter}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MONTHS_FILTER,
            payload: data.response,
        });
        return true;
    }
};

